<template lang="">
      <v-app class="SuccssPage" style="background:rgba(0,0,200,0);">
        <v-container class="justify-center pa-0 pa-md-5" fluid>
            <v-card class="mx-auto mt-0 pb-6" max-width="1300" elevation="10">

                <v-img 
                :src="this.layout.pictures[0]" 
                :max-height="companySpecificConfig.pictureSize">
                </v-img>

                <!-- <v-card-title class="justify-center">{{ $t('thankyou') }}</v-card-title> -->
        <v-card-text>
            <div class="pb-6 ">
                <p 
                class="justify-center"
                v-html="this.companySpecificConfig.thankYouTexts[this.pickedLanguage]"
                ></p>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-row 
            flex
            >
                <v-col 
                cols="12"
                xs="12"
                :sm=countCols()
                v-for="n in this.getNumberOfLinks()"
                :key="n"
                class="d-flex justify-center"
                >
                    <v-btn
                        color="primary"
                        :href="getLinkUrl(n)"
                        target="_blank"
                    >
                        {{ getLinkDesc(n) }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</v-container>
</v-app>
</template>
<script>
export default {

    computed: {
    companySpecificConfig: {
      get() { return this.$store.state.companySpecificConfig }
      },
    pickedLanguage: {
      get() { return this.$store.state.pickedLanguage }
    },
    layout: {
      get() { return this.$store.state.pickedLayout },
    },
    },
    methods: {
    
    //state in Link which of the config links you want to access. 
    getNumberOfLinks() {
        let count = 0
        //just here because lint throws errors if i is loop is not used
        for (let some in this.companySpecificConfig.links) {
            console.log(some)
            count += 1 
        }
        return count
    },
      getLinkDesc(link) {
          //insert integer. funciton then looks up this link-value in the config
        //   let string = 'link' + link
          return this.companySpecificConfig.links['link' + link][this.pickedLanguage].desc //, this.pickedLanguage].desc
      },
      getLinkUrl(link) {
          return this.companySpecificConfig.links['link' + link][this.pickedLanguage].url //, this.pickedLanguage].desc
      },
      countCols() {
          let count = this.getNumberOfLinks()
          if (count <= 1) {
              return 12
          } else if (count == 2) {
              return 6
          } else if (count == 3) {
              return 4
          } else {
              return 3
          }
      }
    },
}
</script>
<style lang="">
    
</style>